import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import api from "../../api";

const DynamicCampus = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        const response = await api.get("api/home-campus");
        setSections(response.data.data || []);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchSections();
  }, []);

  // Slider settings
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  if (loading) return <></>;
  if (error) return <></>;

  const shouldUseSlider = sections.length > 3;

  return (
    <>
      <section className="essentials-area">
        <div className="auto-container">
          <div className="row">
            <div className="col-xl-12 px-lg-auto px-0">
              <div className="features-style1-content">
                {/* Single Title for Section */}
                <h1
                  style={{
                    textAlign: "center",
                    color: "#fff",
                    padding: "16px 0 0 0",
                  }}
                >
                  {sections.length > 0 && sections[0].title}
                </h1>

                {shouldUseSlider ? (
                  // Slider Layout for more than 3 items
                  <div className="mt-lg-5 mt-md-4 mt-3">
                    <Slider {...sliderSettings}>
                      {sections.map((item) => (
                        <div key={item.id} className="px-2">
                          <div className="single-features-style1">
                            <div className="img-box position-relative">
                              {item.media ? (
                                <div className="campus-img-wrapper d-flex justify-content-center align-items-center">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/public/${item.media}`}
                                    alt={item.alt_text || item.name}
                                  />
                                </div>
                              ) : (
                                <></>
                              )}
                              <h2>
                                <a
                                  href={item.buttons[0]?.link || "#"}
                                  target={item.buttons[0]?.target || "_self"}
                                  rel={
                                    item.buttons[0]?.target === "_blank"
                                      ? "noopener noreferrer"
                                      : ""
                                  }
                                >
                                  {item.name}
                                </a>
                              </h2>
                            </div>
                            <div className="text-box">
                              <div className="mt-4">
                                {item.buttons &&
                                  item.buttons.map((btn, idx) => (
                                    <a
                                      key={idx}
                                      className="btn-one mb-lg-3 mb-0 me-3 mt-1"
                                      href={btn.link || "#"}
                                      target={btn.target || "_self"}
                                      rel={
                                        btn.target === "_blank"
                                          ? "noopener noreferrer"
                                          : ""
                                      }
                                    >
                                      <span
                                        className="txt"
                                        style={{ fontSize: "10px" }}
                                      >
                                        {btn.text}
                                      </span>
                                    </a>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                ) : (
                  // Original List Layout for 3 or fewer items
                  <ul className="mt-lg-5 mt-md-4 mt-3">
                    {sections.map((item) => (
                      <li key={item.id}>
                        <div className="single-features-style1">
                          <div className="img-box position-relative">
                            {item.media ? (
                              <div className="campus-img-wrapper d-flex justify-content-center align-items-center">
                                <img
                                  src={`${process.env.REACT_APP_API_URL}/public/${item.media}`}
                                  alt={item.alt_text || item.name}
                                />
                              </div>
                            ) : (
                              <></>
                            )}
                            <h2>
                              <a
                                href={item.buttons[0]?.link || "#"}
                                target={item.buttons[0]?.target || "_self"}
                                rel={
                                  item.buttons[0]?.target === "_blank"
                                    ? "noopener noreferrer"
                                    : ""
                                }
                              >
                                {item.name}
                              </a>
                            </h2>
                          </div>
                          <div className="text-box">
                            <div className="mt-4">
                              {item.buttons &&
                                item.buttons.map((btn, idx) => (
                                  <a
                                    key={idx}
                                    className="btn-one mb-lg-3 mb-0 me-3 mt-1"
                                    href={btn.link || "#"}
                                    target={btn.target || "_self"}
                                    rel={
                                      btn.target === "_blank"
                                        ? "noopener noreferrer"
                                        : ""
                                    }
                                  >
                                    <span
                                      className="txt"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {btn.text}
                                    </span>
                                  </a>
                                ))}
                            </div>
                          </div>
                        </div>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DynamicCampus;